import { request } from '~/api/_utils/request';

const PATH = '/v1/reviews';

/**
 * reviews は replies にリプレースされ、廃止予定
 */
export type ApiBodyReview = {
  postable_type?: string;
  postable_id?: number | string;
  text?: string;
  corp_furusato_id?: number;
  organization_id?: number;
  presentation_id?: number;
  post_id?: number;
  images?: string[];
};

export async function apiPostV1Reviews(review: ApiBodyReview) {
  const response = await request.POST<{}>(PATH, { review });
  return response;
}
